import { render, staticRenderFns } from "./LayoutContentTeacher.vue?vue&type=template&id=e8769360&"
import script from "./LayoutContentTeacher.vue?vue&type=script&lang=js&"
export * from "./LayoutContentTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports